import { Image } from "antd";
import noImage from "../../assets/no-image.avif";

import React from "react";
import { MdDelete } from "react-icons/md";
import { getFileIcon } from "../../utils/SendFile";
import { isImageFile } from "../../utils/Utils";

const UploadedFilePreview = ({ originNode, file, onDelete }) => {
  return React.cloneElement(originNode, {
      className: `${originNode.props.className || ""} group relative`,
      children: (
      <div className="relative w-full h-full flex justify-center items-center bg-[#fafafa] rounded-md overflow-hidden">
        {isImageFile(file?.originalName || file?.fileName) ? (
          <Image
            preview={false}
            height={"84px"}
            width={"auto"}
            src={file?.mainPath || file?.url || file?.preview}
            fallback={noImage}
          />
        ) : (
          <div className="flex flex-col justify-center items-center w-full h-full">
            <div className="w-[40px] h-[40px] flex justify-center items-center">
              {getFileIcon(file?.originalName)}
            </div>
            <span className="mt-1 text-xs text-center px-1 truncate w-full">
              {file?.originalName}
            </span>
          </div>
        )}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(file?.mainPath || file?.uid);
          }}
          className="absolute top-1 right-1 bg-white rounded-full p-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity z-[10]"
        >
          <MdDelete className="text-[red]" size={18} />
        </button>
      </div>
    ),
  });
};

export { UploadedFilePreview };
